<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Course Materials</h3>
</div>
<div class="modal-body">
    <div class="row" *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
        <div class="col-lg-12 col-md-12 col-12">
            <a href="/Document/GetDBAttachment?attachmentID={{file.FileAttachmentID}}"> {{file.AttachmentFileName}}</a>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Close</button>
</div>